module.exports = __webpack_public_path__ + "static/media/ic-settings.681cba74.svg";